import { Box, ModBox, Spacer, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { ButtonNew } from '../../../../components/AdminButton'
import { useEffect, useState } from 'react'
import { useStores } from '../../../../data/store'
import { SelectParentEntityList } from '../CreateEntity/SelectParentEntityList'

const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
}

const headerData = [
  {
    title: 'Processors',
  },
  {
    title: 'Enable/Disable',
  },
]

const PartnerProcessorSettings = ({ isEdit }: any) => {
  const { updateBankOrPartnerConfigs, partnerMeMid, s2sUrl, updatePartnerConfig, getPartnersList, updatedPartners } =
    useStores((store) => ({
      updateBankOrPartnerConfigs: store.onboarding.updateBankOrPartnerConfigs,
      partnerMeMid: store.onboarding.bankRPartnerConfig.partnerMeMid,
      s2sUrl: store.onboarding.bankRPartnerConfig.s2sUrl,
      updatePartnerConfig: store.onboarding.updatePartnerConfig,
      getPartnersList: store.onboarding.getPartnersList,
      updatedPartners: store.onboarding.updatedPartners,
    }))
  const [listData, setListData] = useState([])

  useEffect(() => {
    setListData(getPartnersList())
  }, [getPartnersList, updatedPartners])

  const onAddPress = () => {}

  const onCheckboxPress = (item: any, isChecked: boolean) => {
    console.log('PartnerProcessorSettings onCheckboxPress: ', JSON.parse(JSON.stringify(item)), isChecked)
    updatePartnerConfig('SUPPORTED_PROCESSING_ENTITY', item?.partnerName, isChecked)
  }
  return (
    <Box f={1} overflow={'auto'} pv={32}>
      <ModBox show={false} direction="row" marginTop={32} alignItems={'center'}>
        <ModBox minWidth={200}>
          <TextInputNew
            value={partnerMeMid}
            {...styles.textinput}
            label={'Partner/Processor ID'}
            focusBorderColor={'DISABLED_GREY'}
            onChange={(val: any) => updateBankOrPartnerConfigs('partnerMeMId', val)}
          />
        </ModBox>
        <Spacer size={32} direction={'horizontal'} />
        <ModBox minWidth={200}>
          <TextInputNew
            value={s2sUrl}
            {...styles.textinput}
            label={'Secret/client code'}
            focusBorderColor={'DISABLED_GREY'}
            onChange={(val: any) => updateBankOrPartnerConfigs('s2sUrl', val)}
          />
        </ModBox>
        <Spacer size={32} direction={'horizontal'} />
        <ModBox marginTop={28}>
          <ButtonNew
            type={'secondaryIconSmall'}
            borderWidth={1}
            title={'Add'}
            borderColor={'#0070B6'}
            borderRadius={4}
            icon="ADD"
            onPress={onAddPress}
          />
        </ModBox>
      </ModBox>
      <SelectParentEntityList
        title={''}
        hide={false}
        data={listData}
        columnFlexMapper={flexMapperWithIndex}
        headerTitles={headerData}
        isEditMode={isEdit}
        onCheckboxPress={onCheckboxPress}
      />
    </Box>
  )
}

export { PartnerProcessorSettings }
const styles = {
  textinput: {
    borderRadius: 4,
    borderColor: 'DISABLED_GREY',
    height: 32,
    type: 'body12',
    labelPaddingBottom: 8,
    labelFontFamily: 'jiotype-bold',
    fontFamily: 'jiotype-medium',
    labelColor: 'BRAND_COLOR_GRAY_1',
    labelFontSize: 12,
    fontSize: 12,
    paddingHorizontal: 8,
  } as TextInputNewProps,
}
